import { Button, Modal, ModalBody } from 'reactstrap';

export type ImageModalProps = {
    isOpen: Boolean;
    toggle: () => void;
    image_url: string;
    filename: string;
};

export const ImageModal = (props: ImageModalProps) => {
    const { isOpen, toggle, image_url, filename } = props;

    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <img src={image_url} alt={filename} />
                <p className='small mt-3'>{filename}</p>
                <Button color='outline-dark' size='sm' onClick={toggle}>
                    Close
                </Button>
            </ModalBody>
        </Modal>
    );
};
